import React, { useContext, useEffect } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import useSectorService from '../../../app/services/hooks/useSectorService';

interface Props {
    sectorId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const SectorSwitchChange = ({ sectorId, checkValue, callbackSuccess }: Props) => {
    const { hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { activeSector } = useSectorService();

    useEffect(() => {
        setChecked(checkValue);
    }, [checkValue]);

    const active = (value: boolean) => {
        setChecked(value);
        activeSector(sectorId, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={sectorId} callback={active} />;
};

export default SectorSwitchChange;
